export function getLanguageCode(language: string) {
  switch (language) {
    case 'Francais':
      return 'fr';
    case 'Italian':
      return 'it';
    case 'Deutsch':
      return 'de';
    case 'Nederlands':
      return 'nl';
    case 'Dansk':
      return 'da';
    default:
      return 'en';
  }
}

export function getLanguageString(language: string) {
  switch (language) {
    case 'fr':
      return 'Francais';
    case 'it':
      return 'Italian';
    case 'de':
      return 'Deutsch';
    case 'nl':
      return 'Nederlands';
    case 'da':
      return 'Dansk';
    default:
      return 'English';
  }
}
